import React, { useMemo } from 'react';
import PageFooter from 'components/common/general/layouts/PageFooter';
import { GenerateLinkStep } from 'components/utility/employee-self-register-link/GenerateLinkStep';
import { ShareLinkStep } from 'components/utility/employee-self-register-link/ShareLinkStep';
import {
  EmployeeSelfRegisterLinkPageStore,
  EmployeeSelfRegisterLinkPageStoreContext,
  useEmployeeSelfRegisterLinkPageStore,
} from 'store/pages/utility/employee-self-register-link/pageStore';
import { OverlaySpinner, PageHeader, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { SELF_REGISTER_LINK_PAGE_SPINNER_TEST_ID } from 'components/utility/employee-self-register-link/constants';
import { NarrowPageWrapperStyled } from '../../../globalStyles';
import { ContentWrapperStyled } from './styles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const history = useHistory();
  const { isLoading } = useEmployeeSelfRegisterLinkPageStore();

  return (
    <NarrowPageWrapperStyled>
      <PageHeader
        title="Employee Self-Registration Link"
        subtitle="Let employees register themselves in just two steps"
        onBackButtonClick={() => {
          history.goBack();
        }}
      />
      <ContentWrapperStyled>
        <GenerateLinkStep />
        <ShareLinkStep />
        <OverlaySpinner display={isLoading} data-test-id={SELF_REGISTER_LINK_PAGE_SPINNER_TEST_ID} />
      </ContentWrapperStyled>
      <PageFooter
        onBack={() => {
          history.goBack();
        }}
      />
    </NarrowPageWrapperStyled>
  );
});

const EmployeeSelfRegisterLinkPage: React.FC = () => {
  const query = useQueryParams();

  const groupId = query.get('groupId') || '';

  const pageStore = useMemo(() => new EmployeeSelfRegisterLinkPageStore({ groupId }), []);

  return (
    <EmployeeSelfRegisterLinkPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </EmployeeSelfRegisterLinkPageStoreContext.Provider>
  );
};

export default EmployeeSelfRegisterLinkPage;
